import PropTypes from "prop-types";
import React, { Component } from "react";

//Simple bar
import SimpleBar from "simplebar-react";

// MetisMenu
import MetisMenu from "metismenujs";
import { withRouter } from "react-router-dom";
import { Link } from "react-router-dom";

//i18n
import { withTranslation } from "react-i18next";

let isSettings = false;
let isAsasm = false;
let isArchivage = false;
let isDod = false;

let rolesTerritoire = ['TER_NORD_EST','TER_NORD_OUEST','TER_SUD_EST','TER_SUD_OUEST'];

const getAuthUser = () => {
  if (localStorage.getItem("authUser")) {
    return JSON.parse(localStorage.getItem("authUser"));
  }
}

const checkUserRoles = () => {
  const userRoles = getAuthUser().roles;
    if (userRoles.length > 0) {
      if (userRoles.some(role => role.rolCode === 'EFFI_GEST')) {
        isSettings = true;
      }
      if (userRoles.some(role => role.rolCode === 'MAL_VISU')) {
        isAsasm = true;
      }
      if (userRoles.some(role => role.rolCode === 'MEM_VISU')) {
        isArchivage = true;
      }
      rolesTerritoire.forEach(roleCode => {
        if (userRoles.some( role => role.rolCode === roleCode )) {
          isDod = true;
        }  
      });
    }
}

class SidebarContent extends Component {
  constructor(props) {
    super(props);
    checkUserRoles();
    this.state = {
      showSettings: isSettings,
      showAsasm: isAsasm,
      showArchivage: isArchivage,
      showDod: isDod

    }
    this.refDiv = React.createRef();
  }

  componentDidMount() {
    this.initMenu();
  }

  // eslint-disable-next-line no-unused-vars
  componentDidUpdate(prevProps, prevState, ss) {
    if (this.props.type !== prevProps.type) {
      this.initMenu();
    }
    if (prevProps.success !== this.props.success) {
      const userRoles = getAuthUser();
      if (userRoles) {
        this.setState({ role: userRoles.roles })
      }
    }
  }

  initMenu() {
    new MetisMenu("#side-menu");

    let matchingMenuItem = null;
    const ul = document.getElementById("side-menu");
    const items = ul.getElementsByTagName("a");
    for (let i = 0; i < items.length; ++i) {
      if (this.props.location.pathname === items[i].pathname) {
        matchingMenuItem = items[i];
        break;
      }
    }
    if (matchingMenuItem) {
      this.activateParentDropdown(matchingMenuItem);
    }
  }

  scrollElement = item => {
    setTimeout(() => {
      if (this.refDiv.current !== null) {
        if (item) {
          const currentPosition = item.offsetTop;
          if (currentPosition > window.innerHeight) {
            if (this.refDiv.current)
              this.refDiv.current.getScrollElement().scrollTop =
                currentPosition - 300;
          }
        }
      }
    }, 300);
  };

  activateParentDropdown = item => {
    item.classList.add("active");
    const parent = item.parentElement;

    const parent2El = parent.childNodes[1];
    if (parent2El && parent2El.id !== "side-menu") {
      parent2El.classList.add("mm-show");
    }

    if (parent) {
      parent.classList.add("mm-active");
      const parent2 = parent.parentElement;

      if (parent2) {
        parent2.classList.add("mm-show"); // ul tag

        const parent3 = parent2.parentElement; // li tag

        if (parent3) {
          parent3.classList.add("mm-active"); // li
          parent3.childNodes[0].classList.add("mm-active"); //a
          const parent4 = parent3.parentElement; // ul
          if (parent4) {
            parent4.classList.add("mm-show"); // ul
            const parent5 = parent4.parentElement;
            if (parent5) {
              parent5.classList.add("mm-show"); // li
              parent5.childNodes[0].classList.add("mm-active"); // a tag
            }
          }
        }
      }
      this.scrollElement(item);
      return false;
    }
    this.scrollElement(item);
    return false;
  };

  render() {
    return (
      <React.Fragment>
        <SimpleBar className="h-100" style={{marginTop:'8%'}} ref={this.refDiv}>
          <div id="sidebar-menu" style={{background:'#2a3042'}}>
            {/* <ul className="metismenu list-unstyled" style={this.state.showSettings ? {} : {display: 'none'}} id="side-menu">
              <li className="menu-title">{this.props.t("Paramètrage")}</li>
              <li>
                <Link to="/">
                  <i className="bx bx-info-circle" />
                  <span>{this.props.t("Informations")}</span>
                </Link>
              </li>
              <li>
                <Link to="/">
                  <i className="bx bx-key" />
                  <span>{this.props.t("Clé d'accès client")}</span>
                </Link>
              </li>
            </ul> */}
            <ul className="metismenu list-unstyled" style={this.state.showAsasm ? {} : {display: 'none'}} id="side-menu">
              <li className="menu-title">{this.props.t("Jutificatifs Digitalisation")}</li>
              <li>
                <Link to="/espaceagent">
                  <i className="bx bx-user" />
                  <span>{this.props.t("Espace agent")}</span>
                </Link>
              </li>
              <li style={this.state.showDod ? {} : {display: 'none'}}>
                <Link to="/dod">
                  <i className="bx bx-folder" />
                  <span>{this.props.t("DOD")}</span>
                </Link>
              </li>
            </ul>
            <ul className="metismenu list-unstyled" style={this.state.showArchivage ? {} : {display: 'none'}} id="side-menu">
              <li className="menu-title">{this.props.t("Archivage (ITSOFT)")}</li>
              <li>
                <Link to="/dossiercgos">
                  <i className="bx bx-folder" />
                  <span>{this.props.t("Dossiers C.G.O.S")}</span>
                </Link>
              </li>
             {/*  <li>
                <Link to="/autresdocuments">
                  <i className="bx bx-folder" />
                  <span>{this.props.t("Autres documents")}</span>
                </Link>
              </li> */}
            </ul>
            {/* <ul className="metismenu list-unstyled" id="side-menu">
              <li className="menu-title">{this.props.t("Flux prestataires")}</li>

              <li>
                <Link to="/factures">
                  <i className="bx bx-folder" />
                  <span>{this.props.t("Factures")}</span>
                </Link>
              </li>
              <li>
                <Link to="/voyagistes">
                  <i className="bx bx-file" />
                  <span>{this.props.t("Voyagistes")}</span>
                </Link>
              </li>
              <li>
                <Link to="/billeteries">
                  <i className="bx bx-file" />
                  <span>{this.props.t("Billeteries")}</span>
                </Link>
              </li>
            </ul> */}
          </div>
        </SimpleBar>
      </React.Fragment>
    );
  }
}

SidebarContent.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
  type: PropTypes.string,
};

export default withRouter(withTranslation()(SidebarContent));